module.exports = __webpack_public_path__ + "img/flogo.e24aec97.jpg";